import React, { useRef, useState } from 'react';
import { SIDEBAR_TYPE, ToolbarItem } from '@amzn/aac-chrome-internal-api';
import { ToolbarItemProps } from '../../store/slice';
import {
  MobileDivider,
  MobileSideNavItemText,
  MoreToolsMenuItem,
  NonExpandableItemLink,
} from './styles';
import ExpandableMenuItem from './ExpandableMenuItem';
import MoreToolsView from './MoreToolsView';
import { MobileNavSheet } from './MobileNavSheet';
import { renderFlag } from 'src/commons/components/LaunchFlag/LaunchFlag.utils';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';

const MobileSideNavItem: React.VFC<ToolbarItem> = (
  sideNavItem: ToolbarItem,
) => {
  const moreToolsRef = useRef(null);
  const [isMoreToolsOpen, setIsMoreToolsOpen] = useState(false);
  if (sideNavItem.sidebarType == SIDEBAR_TYPE.DIVIDER) {
    return <MobileDivider />;
  }
  if (!sideNavItem.sidebarGroups) {
    return null;
  }
  const item = sideNavItem as ToolbarItemProps;

  if (item.sidebarType == SIDEBAR_TYPE.TOOL) {
    return (
      <>
        <MoreToolsMenuItem
          ref={moreToolsRef}
          onClick={() => setIsMoreToolsOpen(true)}
          {...getTaktAttributes(item.id, chromeComponents.NAV, {
            url: item.sidebarGroups[0].links[0]?.link.url,
          })}
          data-ccx-e2e-id={item.id}
        >
          <img src={item.iconPath} alt={item.toolTip} />
          {item.toolTip}
        </MoreToolsMenuItem>
        <MobileNavSheet
          isOpen={isMoreToolsOpen}
          onClose={() => setIsMoreToolsOpen(false)}
          closeButton={{
            type: 'icon',
            label: 'close',
          }}
          type="dark"
          side="start"
        >
          <MoreToolsView {...item} />
        </MobileNavSheet>
      </>
    );
  } else if (
    item.sidebarGroups.length == 1 &&
    item.sidebarGroups[0].links.length == 1
  ) {
    return (
      <NonExpandableItemLink
        href={item.sidebarGroups[0].links[0].link.url}
        isSelected={item.sidebarGroups[0].links[0].isSelected}
        {...getTaktAttributes(
          item.sidebarGroups[0].links[0].id,
          chromeComponents.NAV,
          { url: item.sidebarGroups[0].links[0]?.link.url },
        )}
        data-ccx-e2e-id={item.sidebarGroups[0].links[0].id}
      >
        <img src={item.iconPath} alt={item.toolTip} />
        <MobileSideNavItemText>
          {item.sidebarGroups[0].links[0].link.label}
          {renderFlag(item.sidebarGroups[0].links[0], {
            isMobile: true,
            isInverted: true,
          })}
        </MobileSideNavItemText>
      </NonExpandableItemLink>
    );
  } else {
    return <ExpandableMenuItem {...item} />;
  }
};

export default MobileSideNavItem;
